import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useMachine } from "../machine/use-machine";
import { useMTUs } from "../mtu/use-mtus";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { QAPPMain_GF_ManageMarking } from "@/odata/appu4dm/QAppU4DM";
import {
  APPMain_GF_ManageMarking2Params,
  APPMain_GF_ManageMarkingResponse,
} from "@/odata/appu4dm/AppU4DMModel";
import { odataFetch } from "@/lib/odata-fetch";

export function useManageMarking() {
  const { machine } = useMachine();
  const { selected } = useMTUs();
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: (taskId: string) =>
      postManageMarking(
        {
          taskId,
          machineId: machine!.EquipmentNId!,
          mtu: selected!.DM_MaterialTrackingUnit.MaterialTrackingUnit.Code!,
        },
        token!
      ),
  });

  return {
    sendMarkingCommand: mutate,
    ...mutation,
  };
}

type Payload = {
  mtu: string;
  taskId: string;
  machineId: string;
};

async function postManageMarking(payload: Payload, token: string) {
  const builder = createQueryBuilderV4(
    "APPMain_GF_ManageMarking",
    new QAPPMain_GF_ManageMarking()
  );

  return odataFetch<
    APPMain_GF_ManageMarkingResponse,
    APPMain_GF_ManageMarking2Params
  >({
    method: "POST",
    builder,
    token,
    body: {
      command: {
        EquipmentNId: payload.machineId,
        TaskId: payload.taskId,
        PLCHandshake: null,
        NodeInstance: null,
        PCHandshake: null,
      },
    },
  });
}
